import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  TextAttributesGroup,
  TextAttribute,
} from '../../../interfaces/text-attribute/TextAttribute';

export interface OnAttributeSelectArgs {
  attribute: TextAttribute;
  isFormAttribute?: boolean;
}

@Component({
  selector: 'add-attribute-popup',
  template: require('./add-attribute-popup.component.pug'),
  styles: [require('./add-attribute-popup.component.css').toString()],
})
export class AddAttributePopupComponent {
  @Input()
  isVisible: boolean;
  @Input()
  isLoading: boolean;
  @Input()
  hasFormAttributeOption: boolean;
  @Input()
  attributes: TextAttributesGroup[];
  @Input()
  formAttributes: TextAttributesGroup[];
  @Input()
  containerNgStyle: { [cssProperty: string]: any };

  @Output()
  onOutsideClick = new EventEmitter<void>();
  @Output()
  onCloseClick = new EventEmitter<void>();
  @Output()
  onAttributeSelect = new EventEmitter<OnAttributeSelectArgs>();

  searchText = '';
  isFormAttribute = false;

  handleOnAttributeClick(attribute: TextAttribute) {
    this.onAttributeSelect.emit({
      attribute,
      isFormAttribute: this.hasFormAttributeOption
        ? this.isFormAttribute
        : undefined,
    });
  }

  onOutsideClickInner() {
    this.onOutsideClick.emit();
  }

  toggleIsFormAttribute() {
    this.isFormAttribute = !this.isFormAttribute;
  }
}
